import { NgModule } from "@angular/core";
import { CurrencyFormatterPipe } from "./currency-formatter.pipe";
import { CurrencyFormatterPortfolioPipe } from './currency-formatter-portfolio.pipe';

@NgModule({
    declarations: [CurrencyFormatterPipe, CurrencyFormatterPortfolioPipe],
    exports: [CurrencyFormatterPipe, CurrencyFormatterPortfolioPipe]
})
export class CurrencyFormatterPipeModule { }